// extracted by mini-css-extract-plugin
export default {"iconContainer":"HeaderIcon_iconContainer__8MQh-","icon":"HeaderIcon_icon__3Yu+7"};